module.exports = __webpack_public_path__ + "img/sa.c36d1991.svg";